import React, { useEffect, useState } from "react";
import statsApi from "../../../../api/stats-api";
import { getRequestError } from "../../../../utils/functions";
import moment from "moment";
import useStyles from "../MainDashboard/MainDashboard.styles";
import DateSelector from "../../../../components/Inputs/DateSelector";
import Chart from "../../../../components/Chart";
import generateChart from "../utils/graphs";
import { CSVLink } from "react-csv";
import DownloadIcon from "@material-ui/icons/GetApp";

const LoyaltyChurnRate = ({ jwt }) => {
  const [startDate, setStartDate] = useState(
    moment()
      .subtract(1, "months")
      .format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
  const [isLoading, setisLoading] = useState(false);
  const [loyaltyChurnRate, setLoyaltyChurnRate] = useState(null);

  const { filter, filterContainer } = useStyles({
    active: false
  });

  return (
    <div>
      <div>
        <Chart
          data={loyaltyChurnRate || []}
          type="churn"
          title="Churn Rate"
          height={80}
          xLabel="Months"
          yLabel="Users"
          hasFullReport={false}
          loading={isLoading}
          filterComponent={
            <div className={filterContainer}>
              <CSVLink
                data={
                  loyaltyChurnRate?.labels.map((item, index) => ({
                    date: item,
                    rate: loyaltyChurnRate?.datasets[0].data[index]
                  })) ?? []
                }
                filename={"loyalty-revenue-breakdown.csv"}
              >
                <button disabled={isLoading} className="export-btn">
                  <DownloadIcon color="#A233E2" />
                  EXPORT REPORT
                </button>
              </CSVLink>
              <div className={filter}>
                <DateSelector
                  value={startDate}
                  onChange={e => setStartDate(moment(e).format("YYYY-MM-DD"))}
                />
              </div>
              <div className={filter}>
                <DateSelector
                  value={endDate}
                  onChange={e => setEndDate(moment(e).format("YYYY-MM-DD"))}
                />
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default LoyaltyChurnRate;
